export default {
  close: 'Schließen',
  cancel: 'Abbrechen',
  save: 'Speichern',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  submit: 'Absenden',
  reset: 'Zurücksetzen',
  download: 'Herunterladen',
  dataIterator: {
    pageText: '{0}-{1} von {2}',
    noResultsText: 'Kein passenden Eintrag gefunden',
    loadingText: 'Lade Einträge...',
  },
  dataTable: {
    itemsPerPageText: 'Einträge pro Seite:',
    ariaLabel: {
      sortDescending: ': Absteigend sortiert. Aktivieren Sie diese Option, um die Sortierung zu entfernen.',
      sortAscending: ': Aufsteigend sortiert. Aktivieren Sie diese Option, um absteigend zu sortieren.',
      sortNone: ': Nicht sortiert. Aktivieren Sie diese Option, um aufsteigend zu sortieren.',
    },
    sortBy: 'Sortiert nach',
  },
  dataFooter: {
    pageText: '{0}-{1} von {2}',
    itemsPerPageText: 'Einträge pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
  },
  datePicker: {
    itemsSelected: '{0} ausgewählt',
  },
  noDataText: 'Keine Daten verfügbar',
  carousel: {
    prev: 'Vorheriges Bild',
    next: 'Nächstes Bild',
  },
  calendar: {
    moreEvents: '{0} mehr',
  },
  sidebar: {
    dashboard: 'Dashboard',
    overview: 'Übersicht',
    general: 'Generell',
    machine: 'Maschine',
    dataController: 'DataController',
    features: 'Erweiterungen',
    weavingMachine: {
      title: 'Webmaschine',
      settings: 'Einstellungen',
      statistics: 'Statistiken',
    },
    machineStats: {
      title: 'Maschinen Stats',
      overview: 'Übersicht',
      summarize: 'Zusammengefasst',
      statistics: 'Statistiken',
      realtime: 'Realtime',
    },
    annotations: {
      title: 'Anmerkungen',
      settings: 'Einstellungen',
      form: 'Formular',
    },
    views: 'Ansichten',
    fullscreenStatistics: {
      title: 'Vollbild Statistiken',
      weavingMachine: 'Webmaschine',
      overview: 'Übersicht',
    },
    settings: 'Einstellungen',
    management: {
      title: 'Verwaltung',
      users: 'Benutzer',
      groups: 'Gruppen',
    },
    support: 'Support',
    preferences: 'Einstellungen',
    feedback: 'Feedback senden',
    help: 'Hilfe',
  },
  machine: 'Maschine',
  dataController: 'DataController',
  identifier: 'Kennung',
  name: 'Name',
  unit: 'Einheit',
  factor: 'Faktor',
  tag: 'Tag',
  actions: 'Aktionen',
  search: 'Suche',
  newItem: 'Neues Element',
  editItem: 'Element bearbeiten',
  weavingMachine: 'Webmaschine',
  frameSite: 'Gatterseite',
  frameDepth: 'Gattertiefe',
  frameColumn: 'Gatterspalte',
  frameRow: 'Gatterreihe',
  article: 'Artikel',
  initial: 'Initial',
  current: 'Momentan',
  percent: 'Prozent',
  on: 'Ein',
  off: 'Aus',
  working: 'Arbeiten',
  start: 'Start',
  stop: 'Stop',
  last: 'Letzten',
  day: 'Tag',
  week: 'Woche',
  month: 'Monat',
  year: 'Jahr',
  daily: 'Täglich',
  weekly: 'Wöchentlich',
  monthly: 'Monatlich',
  all: 'Alle',
  default: 'Standard',
  time: 'Zeit',
  produced: 'Produziert',
  productionOverview: 'Produktionsübersicht',
  generalInformation: 'Generelle Informationen',
  workingStatus: 'Produktionszeit',
  powerStatus: 'Betriebszeit',
  color: 'Farbe',
  text: 'Text',
  annotations: 'Anmerkungen',
  annotation: 'Anmerkung',
  annotationForm: 'Anmerkungsformular',
  user: 'Benutzer',
  username: 'Benutzername',
  password: 'Passwort',
  groups: 'Gruppen',
  group: 'Gruppe',
  permissions: 'Berechtigungen',
  preferences: 'Einstellungen',
  selectLanguage: 'Sprache auswählen',
  darkTheme: 'Dunkles design',
  english: 'Englisch',
  german: 'Deutsch',
  dataCube: 'DataCube',
  generalErrorMessage: 'Ein Fehler ist aufgetreten',
  savedSuccessfully: '{0} wurde erfolgreich gespeichert',
  deletedSuccessfully: '{0} wurde erfolgreich gelöscht',
  generalDeleteMessage: 'Möchten Sie dieses Element wirklich löschen?',
  email: 'E-Mail',
  emailReports: 'E-Mail Berichte',
  selectInterval: 'Interval auswählen',
  rules: {
    minLength: 'Die Mindestlänge ist {0} Zeichen.',
  },
};
